import React from 'react';
import clsx from 'clsx';
import { Header } from 'semantic-ui-react';
import { endpoints } from '@/constants/urls';
import MarkdownRender from '@/components/text-editors/MarkdownRender';
import RoleActionImage from '@/roles/roleactions/components/RoleActionImage';

const HomePanelLauncher = ({ item, compact }) => (
  <Header
    as="a"
    href={item.href || '#'}
    icon
    textAlign="center"
    className={clsx(`aridhia-${item.name}-launcher`, 'primary')}
    target={item.target === '_blank' ? '_blank' : '_self'}
  >
    <RoleActionImage
      description={item.content}
      name={item.name}
      compact={compact}
      src={`${endpoints.ROLE_ACTION_IMAGES}${item.name.toLowerCase()}.svg`}
    />
    <Header as="h3" className="mt-0 mb-0 primary link f-20" content={item.title} />
    {!compact && (
      <Header.Subheader>
        <div className="max-w-80p db m-auto mt-5" title={item.content}>
          <MarkdownRender
            value={item.content}
            className="home-panel-launcher-markdown f-16"
          />
        </div>
      </Header.Subheader>
    )}
  </Header>
);

export default HomePanelLauncher;
